// extracted by mini-css-extract-plugin
export default {"onTrHover":"ViewDetailsButton_onTrHover__LFJQV"};